import { Link, useLocation } from 'react-router-dom';
import { Camera } from 'lucide-react';

/**
 * Floating Action Button "Probar vino". Aparece en todas las páginas excepto
 * las rutas que ya están enfocadas en agregar/probar (no tendría sentido un FAB
 * que te lleva a la pantalla que ya estás viendo).
 */
const HIDDEN_PATHS = [
  '/tastings/photo',
  '/tastings/new',
];

export function FAB() {
  const location = useLocation();
  const hide =
    HIDDEN_PATHS.some((p) => location.pathname.startsWith(p)) ||
    /\/tastings\/\d+\/edit/.test(location.pathname);

  if (hide) return null;

  return (
    <Link
      to="/tastings/photo"
      aria-label="Probar vino"
      className="
        fixed bottom-5 right-5 z-40
        w-14 h-14 md:w-16 md:h-16
        rounded-full
        bg-emerald-600 text-white
        flex items-center justify-center
        shadow-[0_4px_14px_rgba(16,185,129,0.35)]
        hover:bg-emerald-700
        active:scale-95
        transition
      "
      style={{
        // Respeta la safe area del iPhone (notch + home indicator).
        bottom: 'max(1.25rem, env(safe-area-inset-bottom, 1.25rem))',
        right: 'max(1.25rem, env(safe-area-inset-right, 1.25rem))',
      }}
    >
      <Camera size={24} />
    </Link>
  );
}
